/* eslint-disable import/prefer-default-export */

import getKey from 'lodash/get';
import isFunction from 'lodash/isFunction';
import {
  stringify as stringifyQuery,
} from 'querystring';

import Admin from 'hive-admin';

import PageSingle from 'hive-admin/src/components/PageSingle';
import { PageApprove } from '../routes/approve';

PageSingle.prototype.__renderFound = PageSingle.prototype.renderFound;
PageApprove.prototype.__renderFound = PageApprove.prototype.renderFound;

(
  PageSingle.prototype.renderFound
) = (
  PageApprove.prototype.renderFound
) = function renderPageSingleFound() {
  const { data, client, location, searchParams } = this.props;
  if (
    data
    && searchParams
    && data.systemCountry
    && data.systemCountry !== searchParams.sc
  ) {
    const newPath = `${location.pathname}?${
      stringifyQuery({ ...searchParams, sc: data.systemCountry })
    }`;
    client.storage.setItem('systemCountry', data.systemCountry);
    window.location = newPath;
    return null;
  }
  return this.__renderFound(this);
};

export const getViewerSpecificRole = props => (
    !props.viewer
  ? null
  : props.viewer.role === 'ADMIN'
  ? 'ADMIN'
  : props.viewer.role !== 'SELLER'
  ? null
  : props.viewer.storeType === 'MERCHANT'
  ? 'SELLER_MERCHANT'
  : props.viewer.storeType === 'REFERRAL'
  ? 'SELLER_REFERRAL'
  : props.viewer.storeType === 'RESELLER'
  ? 'SELLER_RESELLER'
  : null
);

Admin.addToLibrary(
  'condition.testFieldValue',
  (field, op, value, parentIndex) => {
    const check = (
        isFunction(op)
      ? null
      : Admin.createFromLibrary('condition.check', {
          path1: field,
          op,
          value2: value,
        })
    );
    return (props) => {
      let fieldValue;
      if (Number.isFinite(parentIndex)) {
        fieldValue = (
            props.forms && props.forms[parentIndex]
          ? props.forms[parentIndex].getFieldValue(field)
          : undefined
        );
        if (typeof fieldValue === 'undefined') {
          fieldValue = (
              props.datas && props.datas[parentIndex]
            ? getKey(props.datas[parentIndex], field, fieldValue)
            : fieldValue
          );
        }
      } else {
        fieldValue = props.form.getFieldValue(field);
        if (typeof fieldValue === 'undefined') {
          fieldValue = getKey(props.data, field, fieldValue);
        }
      }
      return check ? check({ [field]: fieldValue }) : op(fieldValue, props);
    };
  },
);

Admin.addToLibrary(
  'condition.testPageFieldValue',
  (field, op, value) => {
    const check = (
        isFunction(op)
      ? null
      : Admin.createFromLibrary('condition.check', {
          path1: field,
          op,
          value2: value,
        })
    );
    return (props) => {
      let fieldValue = props.pageform.getFieldValue(field);
      if (typeof fieldValue === 'undefined') {
        fieldValue = getKey(props.parentData || props.data, field, fieldValue);
      }
      return check ? check({ [field]: fieldValue }) : op(fieldValue, props);
    };
  },
);

Admin.addToLibrary(
  'condition.viewerSpecificRoleIsNot',
  specificRole => props => (
    getViewerSpecificRole(props) !== specificRole
  ),
);

Admin.addToLibrary(
  'redirect.always',
  (destination = '/') => (
      isFunction(destination)
    ? destination
    : () => destination
  ),
);

Admin.addToLibrary(
  'redirect.viewerSpecificRoleIsNot',
  (specificRole, getDestination) => (props) => {
    if (!props.viewer) {
      return null;
    }
    const currentSpecificRole = getViewerSpecificRole(props);
    if (currentSpecificRole !== specificRole) {
      return getDestination(currentSpecificRole, props);
    }
    return null;
  },
);
